import React from 'react';

/**
 * PageHeader - section header used at the top of every page.
 * Title left, action(s) right (stacks below title on mobile),
 * optional subtitle, and an optional secondary row (filters/search).
 *
 * Props:
 *   title     - string
 *   subtitle  - optional string
 *   action    - optional React node (typically primary buttons)
 *   sticky    - default true; sticks to the top of the scrollable main area
 *   children  - optional secondary row rendered beneath the header bar
 */
export default function PageHeader({
  title,
  subtitle,
  action,
  sticky = true,
  children,
  className = '',
}) {
  return (
    <div
      className={[
        'bg-surface border-b border-line px-4 sm:px-6 lg:px-8 shadow-xs',
        sticky ? 'sticky top-0 z-30' : '',
        className,
      ].join(' ')}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-4 sm:py-5">
        <div className="min-w-0">
          <h1 className="font-heading text-xl sm:text-2xl font-bold text-ink tracking-tight truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-ink-faint line-clamp-2">{subtitle}</p>
          )}
        </div>
        {action && (
          <div className="flex flex-wrap items-center gap-2 shrink-0">{action}</div>
        )}
      </div>
      {children && (
        <div className="pb-4">{children}</div>
      )}
    </div>
  );
}
